// src/utils/anon.ts
export function getAnonId(): string {
    const cookieName = 'pid'; // policyintel id
    const fromCookie = document.cookie
        .split('; ')
        .find(v => v.startsWith(cookieName+'='))
        ?.split('=')[1];

    if (fromCookie) return fromCookie;

    // fallback: localStorage
    let anon = localStorage.getItem('anon_id');
    if (!anon) {
        anon = crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        localStorage.setItem('anon_id', anon);
    }

    // 쿠키 365일
    document.cookie = `${cookieName}=${anon}; Path=/; Max-Age=${60*60*24*365}; SameSite=Lax`;
    return anon;
}
